import { parsePhoneNumberFromString } from "libphonenumber-js";
import { isValidPhoneNumber } from "react-phone-number-input";

// The Natureland OTP API accepts 4-digit codes.
export const BOOKING_OTP_LENGTH = 4;
export const OTP_RESEND_COOLDOWN_SECONDS = 30;

export const normalizeMobileNumber = (mobile = "") =>
  String(mobile).replace(/\D/g, "");

export const getMobileVerificationError = (mobile) => {
  if (mobile == null || (typeof mobile === "string" && !mobile.trim())) return "Mobile number is required";
  if (typeof mobile !== "string") return "Enter a valid mobile number";
  if (!isValidPhoneNumber(mobile)) return "Enter a valid mobile number";

  const parsedNumber = parsePhoneNumberFromString(mobile);
  if (parsedNumber?.country === "SG" && parsedNumber.nationalNumber.length !== 8) {
    return "Singapore mobile numbers must contain 8 digits";
  }

  return "";
};

export const isMobileVerificationValid = ({
  isUserVerified,
  verifiedMobile,
  currentMobile,
}) => {
  const verified = normalizeMobileNumber(verifiedMobile);
  const current = normalizeMobileNumber(currentMobile);

  return Boolean(isUserVerified && verified && current && verified === current);
};

export const canSkipBookingVerification = ({ isTimerActive, isTimesup, timeLeft, ...verification }) =>
  Boolean(isTimerActive && !isTimesup && timeLeft > 0 && isMobileVerificationValid(verification));

export const maskMobileNumber = (mobile = "") => {
  const parsed = parsePhoneNumberFromString(String(mobile));

  if (parsed) {
    const nationalNumber = parsed.nationalNumber || "";
    const visibleDigits = nationalNumber.slice(-2);
    const hiddenDigits = "•".repeat(Math.max(0, nationalNumber.length - 2));
    return `+${parsed.countryCallingCode} ${hiddenDigits}${visibleDigits}`;
  }

  const digits = normalizeMobileNumber(mobile);
  if (!digits) return "your mobile number";
  if (digits.length <= 2) return digits;

  return `${"•".repeat(digits.length - 2)}${digits.slice(-2)}`;
};
